export const notificationConstants = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  MESSAGE: 'message',
  ERROR: 'alert',
  WARNING: 'warning',
  SUCCESS: 'success',
};
